import { format } from 'date-fns/format.js';
import { Notification } from '../models/notification.js';
import {
  DefaultDateTimeFormat,
  NotificationGroups,
  NotificationStatus,
} from '../constants/notifications.js';
import {
  DeleteNotificationsByIdRequest,
  GetNotificationsRequest,
  NotificationPatch,
  PatchNotificationsByIdRequest,
  Notification as Notificationdata,
} from '../api/notifications-api/index.js';
import { isNullOrUndefinedOrEmpty } from '../helper/common.js';

export const mapResourceTypeToNotificationGroups = (
  resourceType: string
): NotificationGroups => {
  switch (resourceType.toLowerCase()) {
    case 'planned maintenance':
      return NotificationGroups.PLANNED_MAINTENANCE;
    case 'incidents':
      return NotificationGroups.INCIDENTS;
    case 'dcim alerts':
      return NotificationGroups.DCIM_ALERTS;
    case 'service tickets':
      return NotificationGroups.SERVICE_TICKETS;
    default:
      return NotificationGroups.PLANNED_MAINTENANCE;
  }
};

export const mapStringToNotificationStatus = (
  status: string
): NotificationStatus => {
  switch (status.toLowerCase()) {
    case 'unread':
      return NotificationStatus.UNREAD;
    case 'read':
      return NotificationStatus.READ;
    default:
      return NotificationStatus.UNREAD;
  }
};

export const mapParametersToNotificationRequest = (
  cursor: string
): GetNotificationsRequest => ({
  sort: '-created_at',
  cursor,
  prefer: [''],
});

export const mapParametersToPatchNotificationRequest = (
  id: string,
  staus: string
): PatchNotificationsByIdRequest => ({
  id,
  notificationPatch: { status: staus } as NotificationPatch,
});

export const mapParametersToDeleteNotificationRequest = (
  id: string
): DeleteNotificationsByIdRequest => ({
  id,
});

export const mapNotificationDataToNotification = (
  response: Notificationdata
): Notification => ({
  subject: response.subject ?? '',
  id: response.id!,
  accountNumber: response.accountNumber ?? '',
  resourceType: mapResourceTypeToNotificationGroups(
    response.resourceType ?? ''
  ),
  subGroup: response.subGroup ?? '',
  resourceId: response.resourceId ?? '',
  status: mapStringToNotificationStatus(response.status ?? ''),
  createdAt: !isNullOrUndefinedOrEmpty(response.createdAt)
    ? format(response.createdAt!, DefaultDateTimeFormat)
    : format(new Date(), DefaultDateTimeFormat),
  createdBy: response.createdBy ?? '',
  locations: response.locations ?? [],
});

export const mapNotificationResponseToNotifications = (
  response: Notificationdata[]
): Notification[] =>
  response.map(element => mapNotificationDataToNotification(element));

export const getNextPageCursorfromQueryParam = (queryUrl: string): string => {
  const searchParams = new URLSearchParams(queryUrl);
  const nextPageCursor = searchParams.has('cursor')
    ? searchParams.get('cursor')
    : '';
  return nextPageCursor !== null ? nextPageCursor : '';
};
